<template>
  <div class="service">
    <div class="fz14 bold fr ac jsb">
      <span>服务订单</span>
    </div>

    <div class="mt30">
      <el-tabs v-model="tab">
        <el-tab-pane label="所有订单" name=""></el-tab-pane>
        <el-tab-pane label="待确认" name="1"></el-tab-pane>
        <el-tab-pane label="已完成" name="2"></el-tab-pane>
        <el-tab-pane label="待评价确认" name="3"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->

      <div>
        <el-input style="width: 336px" placeholder="请输入订单号" size="mini"></el-input>
        <el-button class="ml20" type="primary" size="mini">搜索</el-button>
      </div>

      <div class="info_box">
        <div class="fr ac fz12 mt30">
          <div class="center order-list-item">产品信息</div>
          <div class="center order-list-item">状态</div>
          <div class="center order-list-item">日期</div>
          <div class="center order-list-item">价格</div>
          <div class="center fg">操作</div>
        </div>

        <el-divider/>

        <!--        列表-->

        <div class="order-list fz12">
          <div class="order-item mt20" v-for="(item,index) in service_list" :key="index">
            <!--                上-->
            <div class="top fr ac jsb">
              <p class="ml10">订单号:{{ item.order_no }}</p>
              <span>{{ service_state_decide(item) }}</span>
            </div>
            <!--                中-->

            <div class="fr middle">
              <!-- 商品信息 -->
              <div class="order">
                <div class="fr order_left">
                  <div class="fr ac jc order-list-item">
                    <p class>【{{ item.type_name }}/{{ item.level_name }}】</p>
                  </div>
                  <div class="center order-list-item">{{ service_state_decide(item) }}</div>
                  <div class="center order-list-item">{{ item.create_time }}</div>
                  <div class="center order-list-item">￥{{ item.order_actual_price }}</div>
                </div>
              </div>
              <!-- 操作 -->
              <div class="fc jc ac fg fs operating pl10 pr10 pt10 pb10">
                <!-- 待审核订单 -->
                <template v-if="item.platform_sale_check_state == '0'">
                  <p class="blue cursor" @click="go(`/salesservicedetail?id=${item.order_id}`)">确认订单</p>
                  <p class="mt10 grey cursor" @click="cancelOrder(item.order_id)">驳回订单</p>
                </template>
                <p
                    class="mt10 cursor grey"
                    @click="go(`/salesservicedetail?id=${item.order_id}`)"
                >查看详情</p>
              </div>
            </div>
          </div>
        </div>
        <div class="fr ac jc">
          <el-pagination
              :hide-on-single-page="true"
              class="mt20 mb20"
              layout="prev, pager, next"
              :current-page.sync="page"
              :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      tab: "",
      order_state: "",
      page: 1,
      total: 0,
      service_list: []
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getActive() {
      switch (this.tab) {
        case '0':
          return {
            platform_sale_check_state: "",
          };
        case '1':
          return {
            platform_sale_check_state: "0",
          };
        case '2':
          return {
            platform_sale_check_state: "1",
            assessment_state: "1",
            contract_check_state: '1'
          };
        case '3':
          return {
            platform_sale_check_state: "1",
            assessment_state: "0",
            contract_check_state: '1'
          };
      }
    },
  },
  created() {
  },
  mounted() {
  },
  watch: {
    page(n) {
      this.getSellOrders();
    },
    tab(n) {
      this.getSellOrders();
    }
  },
  methods: {
    // 驳回订单
    cancelOrder(id) {
      this.$confirm("是否驳回该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("serviceInterfaces/v1.0/sellRejectOrder", {
              order_id: id
            }).then(res => {
              this.$message({
                type: "success",
                message: "已取消!"
              });
              this.getSellOrders();
            });
          })
          .catch(() => {
          });
    },
    // 销售-订单列表
    getSellOrders() {
      let obj = {
        page: this.page,
        ...this.getActive
      }
      console.log(obj)
      this.post("serviceInterfaces/v1.0/getSellOrders", obj).then(res => {
        this.total = res.total;
        this.service_list = res.data;
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.service {
  .info_box {
    background-color: #fff;

    .order-list-item {
      &:nth-of-type(1) {
        width: 260px;
      }

      width: 175px;
    }

    .order-list {
      .order-item {
        border: 1px solid #e5e5e5;

        .order-list-item {
          border-right: 1px solid #e5e5e5;

          &:nth-of-type(4) {
            border-right: none;
          }
        }

        .top {
          background-color: #f0f6ff;
          padding: 14px;
          border-bottom: 1px solid #e5e5e5;
        }

        .middle {
          .order {
            .order_left {
              min-height: 80px;
              border-right: 1px solid #e5e5e5;
              border-bottom: 1px solid #e5e5e5;

              &:last-child {
                border-bottom: none;
              }

              .goods_img {
                width: 80px;
                height: 80px;
              }
            }

            .operating {
              .el-button {
                font-weight: normal;
              }

              p {
                margin-top: 10px;

                &:nth-of-type(1) {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/salesservice/index.vue